import React from "react"
import SmartLink from "../layout/SmartLink/SmartLink"

import { InlineText } from "../Typography/Typography"

const ReviewWidget = () => (
  <SmartLink
    newTab
    to="http://www.reviews.co.uk/company-reviews/store/caresourcer-com1"
  >
    <InlineText brand small>
      <img
        src="https://media.reviews.co.uk/badge/caresourcer-com1.png"
        alt="Star rating for caresourcer.com on reviews.co.uk"
        width="130"
        height="80"
      />
    </InlineText>
  </SmartLink>
)

ReviewWidget.propTypes = {}

ReviewWidget.defaultProps = {}

export default ReviewWidget
